export const strings = {
  edit: '編集',
  save: '保存',
  quit: '終了',
  foodInfo: 'フード情報',
}
